export default (id, subjectEnum) => {
  if (Number(id) === 0) return '-1'
  for (let key in subjectEnum) {
    if (subjectEnum[key] === subjectEnum[id] && key > -1) {
      return key
    }
  }
  return '-1'
}



// WEBPACK FOOTER //
// ./src/util/filterSubject.js